import { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';
import { mq } from '~/styles/grid';

export const HoverCommonStyles = css`
  background-color: ${({ theme, isBrand }) =>
    isBrand
      ? getColorByName(theme, theme.cta.brand.tertiaryBgHoverColor)
      : getColorByName(theme, theme.cta.tertiaryBgHoverColor)};
  transition: width 0.3s cubic-bezier(0.76, 0, 0, 1) !important;
  text-decoration: none;
`;

const HoverLineAfter = css`
  ${HoverCommonStyles};
  content: ' ' !important;
  display: block !important;
  width: 0 !important;
  height: 1px !important;
`;

export const HoverLineHoverAfter = css`
  width: 100% !important;
`;

export const HoverLine = css`
  &::after {
    ${HoverLineAfter};
  }

  &:hover::after {
    ${HoverLineHoverAfter};
  }
`;

export const HoverDesktop = css`
  @media (${mq.mdUp}) {
    .text::after {
      ${HoverLineAfter};
    }

    .text:hover::after {
      ${HoverLineHoverAfter};
    }

    &:hover .text::after,
    .iconBefore:hover ~ .text::after,
    .iconAfter:hover ~ .text::after {
      ${HoverLineHoverAfter};
    }
  }
`;
